<template>
  <div id="filesButton">
    <i class="fas fa-camera" v-if="this.show === true"></i>
  </div>
</template>

<script>
export default {
  name: 'FilesButton',
  data () {
    return {
      show: false
    }
  },
  beforeMount () {
    this.show = this.params.show
  }
}
</script>

<style scoped>
  #filesButton {
    width: 100%;
  }
  .fas.fa-camera {
    font-size: 1rem !important;
    cursor: pointer;
    display: block;
    margin: auto;
    padding-top: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/FilesButton.vue